/* Sourcia — runtime for the cloned page.
   The competitor's scripts are stripped at build time: everything interactive
   (carousels, accordions, popups, counters, countdown, buy box) is rebuilt here.
   Product / variant ids come from window.TC_PRODUCT, filled by Liquid. */
(function () {
  var FILTER_PACK_HANDLE = 'pack-12-filtres-sourcia';

  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) {
    return Array.prototype.slice.call((root || document).querySelectorAll(sel));
  }

  var root = $('.tc-clone');
  if (!root) return;

  // ----------------------------------------------------------------
  // Carousels — Swiper is gone: turn each track into a snap scroller
  // ----------------------------------------------------------------
  function unswipe() {
    $$('.swiper', root).forEach(function (sw) {
      if (sw.classList.contains('swiper-vertical')) return;   // thumbs rail
      var wrap = $('.swiper-wrapper', sw);
      if (!wrap || wrap.dataset.tcScroller) return;

      $$('.swiper-slide-duplicate', wrap).forEach(function (d) { d.remove(); });
      wrap.dataset.tcScroller = '1';
      wrap.style.transform = 'none';
      wrap.style.transition = 'none';
      wrap.style.display = 'flex';
      wrap.style.overflowX = 'auto';
      wrap.style.overflowY = 'hidden';
      wrap.style.scrollSnapType = 'x mandatory';
      wrap.style.scrollBehavior = 'smooth';
      wrap.style.scrollbarWidth = 'none';
      $$('.swiper-slide', wrap).forEach(function (s) {
        s.style.scrollSnapAlign = 'start';
        s.style.flex = '0 0 auto';
      });
      sw.style.overflow = 'hidden';
    });
  }

  function trackFor(el) {
    var scope = el.closest('.shopify-section, section, .swiper') || root;
    return $('.swiper-wrapper[data-tc-scroller]', scope) ||
           $('.swiper-wrapper', scope);
  }

  function step(track) {
    var slide = $('.swiper-slide', track);
    if (!slide) return track.clientWidth;
    var rect = slide.getBoundingClientRect();
    var gap = parseFloat(getComputedStyle(track).columnGap || 0) || 0;
    return rect.width + gap;
  }

  function wireArrows() {
    var prev = '.swiper-button-prev,.main-swiper-prev,[class*="__button--prev"],' +
               '[class*="--prev"],.product-media__navigation .prev';
    var next = '.swiper-button-next,.main-swiper-next,[class*="__button--next"],' +
               '[class*="--next"],.product-media__navigation .next';
    $$(prev, root).forEach(function (b) {
      b.addEventListener('click', function (e) {
        e.preventDefault();
        var t = trackFor(b);
        if (t) t.scrollBy({ left: -step(t), behavior: 'smooth' });
      });
    });
    $$(next, root).forEach(function (b) {
      b.addEventListener('click', function (e) {
        e.preventDefault();
        var t = trackFor(b);
        if (t) t.scrollBy({ left: step(t), behavior: 'smooth' });
      });
    });
    $$('.swiper-pagination-bullet', root).forEach(function (b, i) {
      b.addEventListener('click', function (e) {
        e.preventDefault();
        var pag = b.parentElement;
        var idx = Array.prototype.indexOf.call(pag.children, b);
        var t = trackFor(b);
        if (!t) return;
        t.scrollTo({ left: idx * step(t), behavior: 'smooth' });
        $$('.swiper-pagination-bullet', pag).forEach(function (o) {
          o.classList.toggle('swiper-pagination-bullet-active', o === b);
        });
      });
    });
  }

  // product gallery: thumbnail → main media
  function wireGallery() {
    var main = $('.product-media-swiper .swiper-wrapper', root);
    var thumbs = $$('.product-thumbs-swiper .swiper-slide', root);
    if (!main || !thumbs.length) return;
    thumbs.forEach(function (t, i) {
      t.addEventListener('click', function () {
        main.scrollTo({ left: i * step(main), behavior: 'smooth' });
        thumbs.forEach(function (o) {
          o.classList.toggle('swiper-slide-thumb-active', o === t);
        });
      });
    });
  }

  // ----------------------------------------------------------------
  // Accordions / tabs / popups
  // ----------------------------------------------------------------
  function wireAccordions() {
    $$('.el-faq-accordion__summary', root).forEach(function (btn) {
      btn.addEventListener('click', function () {
        var item = btn.closest('.el-faq-accordion__item');
        if (!item) return;
        var open = item.classList.toggle('is-open');
        item.setAttribute('data-el-faq-state', open ? 'open' : 'closed');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        // the panel keeps the competitor's inline height:0 — their JS drove it
        var panel = $('.el-faq-accordion__content', item);
        if (panel) panel.style.height = open ? panel.scrollHeight + 'px' : '0px';
      });
    });
    $$('[data-accordion-header]', root).forEach(function (btn) {
      btn.addEventListener('click', function () {
        var item = btn.closest('.product-desc_accordion_item');
        if (item) item.classList.toggle('open');
      });
    });
    // native <details> need nothing
  }

  function wirePopups() {
    function close(sec) {
      sec.classList.remove('is-active');
      sec.setAttribute('hidden', '');
      document.body.style.overflow = '';
    }
    $$('[data-popup-trigger]', root).forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        var sec = $('[data-popup-content="' + trigger.getAttribute('data-popup-trigger') + '"]', root);
        if (!sec) return;
        sec.removeAttribute('hidden');
        sec.classList.add('is-active');
        document.body.style.overflow = 'hidden';
      });
    });
    $$('[data-popup-close]', root).forEach(function (btn) {
      btn.addEventListener('click', function () {
        var sec = btn.closest('.el-popup-content-section');
        if (sec) close(sec);
      });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      $$('.el-popup-content-section.is-active', root).forEach(close);
    });
  }

  // ----------------------------------------------------------------
  // Stat counters + countdown (their scripts are gone)
  // ----------------------------------------------------------------
  function wireCounters() {
    var nodes = $$('[data-el-count-target]', root);
    if (!nodes.length) return;
    function run(el) {
      if (el.dataset.tcCounted) return;
      el.dataset.tcCounted = '1';
      var target = parseFloat(el.getAttribute('data-el-count-target')) || 0;
      var dec = parseInt(el.getAttribute('data-el-count-decimals') || '0', 10);
      var commas = el.getAttribute('data-el-count-commas') === 'true';
      var start = performance.now(), dur = 1400;
      (function tick(now) {
        var p = Math.min(1, (now - start) / dur);
        var v = (target * (1 - Math.pow(1 - p, 3))).toFixed(dec);
        el.textContent = commas ? Number(v).toLocaleString('fr-FR') : v;
        if (p < 1) requestAnimationFrame(tick);
      })(start);
    }
    if (!('IntersectionObserver' in window)) return nodes.forEach(run);
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) run(en.target); });
    }, { threshold: 0.3 });
    nodes.forEach(function (n) { io.observe(n); });
  }

  function wireCountdown() {
    var bar = $('[id*="countdown-bar-"]', root);
    if (!bar) return;
    var digits = $$('.rhykin-countdown-bar__digits', bar);
    if (digits.length < 3) return;
    var resetHour = parseInt(bar.getAttribute('data-reset-hours') || '13', 10);
    function pad(n) { return (n < 10 ? '0' : '') + n; }
    function tick() {
      var now = new Date();
      var end = new Date(now);
      end.setHours(resetHour, 0, 0, 0);
      if (end <= now) end.setDate(end.getDate() + 1);
      var s = Math.max(0, Math.floor((end - now) / 1000));
      digits[0].textContent = pad(Math.floor(s / 3600));
      digits[1].textContent = pad(Math.floor((s % 3600) / 60));
      digits[2].textContent = pad(s % 60);
    }
    tick();
    setInterval(tick, 1000);
  }

  // ----------------------------------------------------------------
  // Buy box — offers, variants, add to cart
  // ----------------------------------------------------------------
  function selectedBar() {
    var checked = $('input[name^="kaching-bundles-deal"]:checked', root);
    return checked ? checked.closest('.kaching-bundles__bar') : $('.kaching-bundles__bar', root);
  }

  // the clone's option values are the competitor's ("3.2L", "Wired"), ours are
  // translated ("3,2 L", "Filaire") — match by position, loosely
  function looseFind(variants, values) {
    function key(s) { return String(s).toLowerCase().replace(/[\s.,]/g, ''); }
    return variants.filter(function (v) {
      return values.every(function (val, i) {
        var opt = v['option' + (i + 1)];
        return !val || !opt || key(opt) === key(val) ||
               key(opt).indexOf(key(val)) === 0 || key(val).indexOf(key(opt)) === 0;
      });
    })[0];
  }

  function currentVariantId() {
    var p = window.TC_PRODUCT;
    if (!p || !p.variants) return null;
    var bar = selectedBar();
    var values = bar ? $$('select.kaching-bundles-option', bar).map(function (s) { return s.value; }) : [];
    var v = looseFind(p.variants, values) || p.variants[0];
    return v && v.id;
  }

  function syncVariantInput() {
    var input = $('input[name="id"]', root);
    var id = currentVariantId();
    if (input && id) input.value = id;
  }

  function wireOffers() {
    $$('input[name^="kaching-bundles-deal"]', root).forEach(function (radio) {
      radio.addEventListener('change', function () {
        $$('.kaching-bundles__bar', root).forEach(function (b) {
          b.classList.toggle('kaching-bundles__bar--selected',
                             b.contains(radio) && radio.checked);
        });
        syncVariantInput();
      });
    });
    $$('select.kaching-bundles-option', root).forEach(function (sel) {
      sel.addEventListener('change', function () {
        sel.setAttribute('data-value', sel.value);
        // a bar's selects only drive the cart when that bar is the selected one
        var radio = $('input[name^="kaching-bundles-deal"]', sel.closest('.kaching-bundles__bar') || root);
        if (radio && !radio.checked) radio.click();
        syncVariantInput();
      });
    });
    syncVariantInput();
  }

  function isBundleOffer(bar) {
    return !!(bar && $('.kaching-bundles__bundle-products', bar));
  }

  function wireAddToCart() {
    var form = $('form[action*="/cart/add"]', root);
    if (!form) return;
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var btn = $('button[type="submit"]', form);
      var id = currentVariantId();
      if (!id) return;
      if (btn) btn.setAttribute('disabled', '');
      var items = [{ id: id, quantity: 1 }];
      var bundle = isBundleOffer(selectedBar());

      (bundle ? fetch('/products/' + FILTER_PACK_HANDLE + '.js')
                  .then(function (r) { return r.ok ? r.json() : null; })
                  .catch(function () { return null; })
              : Promise.resolve(null))
        .then(function (filterProduct) {
          if (filterProduct && filterProduct.variants && filterProduct.variants[0]) {
            items.push({ id: filterProduct.variants[0].id, quantity: 1 });
          }
          return fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: items })
          });
        })
        .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
        .then(function (res) {
          if (!res.ok) throw new Error(res.d && res.d.description || 'add to cart failed');
          window.location.href = '/cart';
        })
        .catch(function (err) {
          if (btn) btn.removeAttribute('disabled');
          var msg = $('.main-atc__error', form) || $('.product-form__error-message', root);
          if (msg) {
            msg.textContent = "Ajout au panier impossible. Réessayez.";
            msg.style.display = 'block';
          }
          console.error('[sourcia]', err);
        });
    });
  }

  function init() {
    unswipe();
    wireArrows();
    wireGallery();
    wireAccordions();
    wirePopups();
    wireCounters();
    wireCountdown();
    wireOffers();
    wireAddToCart();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
